import React, { useState, useMemo } from "react";
import Stack from "@mui/material/Stack";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

import "react-toastify/dist/ReactToastify.css";

import TbBookingStatus from "./TbBookingStatus";
import TbSelectTestDateAndTimeForTabTwo from "./TbSelectTestDateAndTimeForTabTwo";
import TbCheckingBookingData from "./TbCheckingBookingData";

/*------------------- Style --------------------------*/
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#FFF",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  //textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "THSarabunNew",
      fontSize: 14,
    },
  },

  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          backgroundColor: grey["200"],
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: 30,
        },
      },
    },
  },
});

/*------------------------------ ContentTapOne -------------------------------------*/
function ContentTapTwo(props) {
  /*----------------------------- Show/Hide Checking Panel -----------------*/
  const [checkingpanel, setHideCheckingPanel] = useState(false);
  const [newdate, setNewDate] = useState(props.date);
  const updateddate = useMemo(() => newdate, [newdate]);

  /*----------------------------------- Return --------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={4} sx={{ padding: 4 }}>
        <Item>
          <Stack direction={"row"} spacing={2}>
            <Item>
              <TbSelectTestDateAndTimeForTabTwo
                date={props.date}
                checkpanelstate={checkingpanel}
                tabclosefunc={props.tabclosefunc}
                hidecheckingpanelfunc={setHideCheckingPanel}
                newdatefunc={setNewDate}
              />
            </Item>
            <Item>
              <TbBookingStatus date={updateddate /*newdate*/} />
            </Item>
          </Stack>
        </Item>
        <Item>
          {checkingpanel && (
            <TbCheckingBookingData
              checkpanelstate={checkingpanel}
              tabclosefunc={props.tabclosefunc} //---added on 04-10-2024
              hidecheckingpanelfunc={setHideCheckingPanel}
            />
          )}
        </Item>
      </Stack>
    </ThemeProvider>
  );
}

export default ContentTapTwo;
